// index.js
import { useEffect, useState } from "react";
import InstallationPartner from "./Ip";
import Vendor from "./Vendor";
import { Chip } from "@mui/material";
import MenuButtonWithDatePickers from "../../../shared/utils/DateFilter";
import axios from "axios";

export default function Payments() {
  const [activeTab, setActiveTab] = useState("installation");
  const [ippendingPayments, setIpPendingPayments] = useState(0);
  const [vendorpendingPayments, setVendorPendingPayments] = useState(0);
  const [isIpId, setIsIpId] = useState("");
  const [allIps, setAllIps] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const serverURL = process.env.REACT_APP_URL;

  const token = localStorage.getItem("token");

  useEffect(() => {
    const getInstallationPartnerList = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(
          `${serverURL}/installationPartner/viewAllIpsMap`,
          {
            headers: { Authorization: `Bearer ${token}` },
          },
        );
        if (response?.data?.success) {
          setAllIps(response?.data?.data);
        }
      } catch (error) {
        console.error("Error fetching InstallationPartner:", error);
      }
    };
    getInstallationPartnerList();
  }, []);

  const handleDateChange = async (value) => {
    const { fromDate, toDate } = value?.dateFilter;

    try {
      const res = await axios.get(
        `${serverURL}/installationPartnerPayments/downloadPayments?fromDate=${fromDate}&toDate=${toDate}&ipId=${isIpId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
          responseType: "blob", // 👈 critical for Excel download
        },
      );

      // Convert to Blob for download
      const blob = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "payments_report.xlsx";
      link.click();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Download error:", err);
    }
  };

  const handleDateClose = () => {};

  // Callback function to update pendingPayments
  const handlePendingPaymentsUpdate = (amount, type) => {
    if (type == "ip") {
      setIpPendingPayments(amount);
    } else {
      setVendorPendingPayments(amount);
    }
  };

  return (
    <div className="bg-white pt-3">
      <div className="flex justify-between items-center pb-2 border-b">
        <div className="flex justify-between space-x-4 px-2">
          <button
            className={`px-4 py-2 font-semibold ${
              activeTab === "installation"
                ? "border-b-2 border-blue-500 text-blue-600"
                : "text-gray-500"
            }`}
            onClick={() => setActiveTab("installation")}
          >
            Installation Partner
          </button>
          <button
            className={`px-4 py-2 font-semibold ${
              activeTab === "vendor"
                ? "border-b-2 border-blue-500 text-blue-600"
                : "text-gray-500"
            }`}
            onClick={() => setActiveTab("vendor")}
          >
            Vendor Partner
          </button>
        </div>

        <div className="flex items-center">
          {activeTab === "installation" && (
            <>
              {/* Date Filter Section */}
              <div
                className="date-filter"
                onClick={(event) => {
                  if (anchorEl) {
                    // handleDateClose(); // You can uncomment this if you want to toggle close
                  } else {
                    setAnchorEl(event.currentTarget); // Open the popover
                  }
                }}
              >
                <MenuButtonWithDatePickers
                  onSubmit={handleDateChange}
                  anchorEl={anchorEl}
                  setAnchorEl={setAnchorEl}
                  handleClose={handleDateClose}
                  allIps={allIps}
                  operation="payment"
                  isIpId={isIpId}
                  setIsIpId={setIsIpId}
                  // clearDateFilter={clearDateFilter}
                />
              </div>

              <div className="">
                <Chip
                  label={`${
                    ippendingPayments > 0 ? ippendingPayments : 0
                  } Payments Pending`}
                  sx={{
                    backgroundColor: "#FFD98E",
                    color: "#C77903",
                    margin: "0 1rem",
                    fontWeight: "bold",
                  }}
                />
              </div>
            </>
          )}
        </div>

        {activeTab === "vendor" && vendorpendingPayments > 0 && (
          <Chip
            label={`${vendorpendingPayments} Payments Pending`}
            sx={{
              backgroundColor: "#FFD98E",
              color: "#C77903",
            }}
          />
        )}
      </div>
      {activeTab === "installation" ? (
        <InstallationPartner
          onPendingPaymentsUpdate={handlePendingPaymentsUpdate}
        />
      ) : (
        <Vendor />
      )}
    </div>
  );
}
